import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardActionArea,
  CardMedia,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import currentNews from './newsData';

const useStyles = makeStyles((theme) => ({
  card: {
    width: '400px',
    maxWidth: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
    backgroundColor: theme.palette.custom.cardBackground,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  },

  actionArea: {
    display: 'block',
  },

  mediaWrapper: {
    position: 'relative',
    height: '220px',
    overflow: 'hidden',
  },

  media: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  category: {
    position: 'absolute',
    top: '14px',
    left: '14px',
    padding: '5px 12px',
    borderRadius: '20px',
    backgroundColor: 'rgba(50, 50, 50, 0.75)',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 500,
  },

  content: {
    padding: theme.spacing(2.5),
  },

  metadata: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '14px',
    color: theme.palette.text.secondary,
    fontSize: '13px',
  },

  separator: {
    fontSize: '12px',
  },

  title: {
    marginBottom: '10px',
    color: theme.palette.custom.strongText,
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1.3,
  },

  description: {
    marginBottom: '20px',
    color: theme.palette.text.secondary,
    fontSize: '15px',
    lineHeight: 1.6,
  },

  readMore: {
    color: theme.palette.primary.blue,
    fontSize: '14px',
    fontWeight: 600,
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export default function LatestNews() {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardActionArea
        className={classes.actionArea}
        component={Link}
        to={`/news/${currentNews.slug}`}
      >
        <div className={classes.mediaWrapper}>
          <CardMedia
            className={classes.media}
            component="img"
            image={currentNews.image}
            alt={currentNews.title}
          />

          <Typography className={classes.category}>
            {currentNews.category}
          </Typography>
        </div>

        <div className={classes.content}>
          <div className={classes.metadata}>
            <Typography variant="body2">
              {currentNews.date}
            </Typography>

            <span className={classes.separator}>•</span>

            <Typography variant="body2">
              {currentNews.readTime} min
            </Typography>
          </div>

          <Typography
            component="h3"
            className={classes.title}
          >
            {currentNews.title}
          </Typography>

          <Typography className={classes.readMore}>
            Leer artículo ↗
          </Typography>
        </div>
      </CardActionArea>
    </Card>
  );
}
